import React, { useRef } from "react";
// import { Editor } from "@tinymce/tinymce-react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

export default function RichTextEditor({ setContent, initialValue = "" }) {
  // const editorRef = useRef(null);
  // const log = () => {
  //   if (editorRef.current) {
  //     setContent(editorRef.current.getContent());
  //   }
  // };
  const [value, setValue] = React.useState(initialValue);
  React.useEffect(() => {
    setContent(value);
  }, [value]);

  React.useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);
  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image"],
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
  ];

  return (
    <>
      {/* <Editor
        apiKey={process.env.REACT_APP_TINYMCE_TOKEN}
        onInit={(evt, editor) => (editorRef.current = editor)}
        onChange={() => {
          log();
        }}
        initialValue='<p>Agenda of the meeting</p>'
        init={{
          height: 500,
          menubar: false,
          plugins: [
            "advlist autolink lists link image charmap print preview anchor",
            "searchreplace visualblocks code fullscreen",
            "table paste code help wordcount",
          ],
          toolbar:
            "undo redo | formatselect | " +
            "bold italic underline backcolor | fontselect fontsizeselect formatselect alignleft aligncenter " +
            "alignright alignjustify  |  numlist bullist |",
          content_style:
            "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
        }}
      /> */}
      <ReactQuill
        theme='snow'
        value={value}
        onChange={setValue}
        modules={modules}
        formats={formats}
      />
    </>
  );
}
